// extracted by mini-css-extract-plugin
export default {"form_container":"cartForm_form_container__pQmrY","form_wrap":"cartForm_form_wrap__k8waH","total_wrap":"cartForm_total_wrap__7sIoo"};